import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  }, []);
  useEffect(() => { load(); }, [load]);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <Ctx.Provider value={{ user, setUser, reload: load, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);

const PERMS = {
  manage_users: ["lab_admin"],
  manage_lab: ["lab_admin", "lab_director", "quality_manager"],
  edit_tracker: ["lab_admin", "lab_director", "quality_manager", "technical_manager", "document_preparer"],
  edit_docs: ["lab_admin", "lab_director", "quality_manager", "technical_manager", "document_preparer"],
  approve_docs: ["lab_admin", "lab_director", "quality_manager", "reviewer_approver"],
  edit_qms: ["lab_admin", "lab_director", "quality_manager", "technical_manager", "auditor"],
  verify: ["lab_admin", "lab_director", "quality_manager", "auditor"],
  upload_evidence: ["lab_admin", "lab_director", "quality_manager", "technical_manager", "document_preparer", "auditor"],
  use_ai: ["lab_admin", "lab_director", "quality_manager", "technical_manager", "document_preparer", "reviewer_approver", "auditor"],
  view_personnel: ["lab_admin", "lab_director", "quality_manager", "technical_manager"],
};
export const can = (user, perm) => !!user && (PERMS[perm] || []).includes(user.role);
